import * as React from 'react'
import { connect } from 'react-redux'
import type { State } from 'types/redux'

function mapStateToProps(state: State): any {
  return {
    isSupportUser: state.user.is_support_user,
  }
}

type Props = {
  isSupportUser: boolean
  renderFn: () => React.ReactNode
}

class AdminTool extends React.Component<Props> {
  // experimental
  // function `isAdmin` might be better
  render() {
    if (process.env.NODE_ENV !== 'production' || this.props.isSupportUser) {
      return this.props.renderFn()
    }

    return null
  }
}

export default connect(mapStateToProps)(AdminTool) as any
